<div class="fixed inset-0 top-0 left-0 z-40 flex h-screen w-full min-w-screen items-center justify-center">
  <div class="absolute inset-0 bg-black opacity-30"></div>
  <div class="z-50 mt-16 max-h-[90vh] w-full max-w-3xl overflow-auto bg-white p-8" data-cy="tool-dialog">
    <h2 class="pb-4 text-xl" data-cy="dialog-title">
      {{
        dialogType === EToolListType.SUGGESTION
          ? 'Suggest AI Tool'
          : dialogType === EToolListType.REVIEW
            ? 'Share Your Experience'
            : 'Share a Use Case for AI Tools'
      }}
    </h2>
    @if (dialogType === EToolListType.SUGGESTION) {
      <form [formGroup]="toolSuggestionForm" (ngSubmit)="onSubmitSuggestion()" class="flex flex-col items-center">
        <div class="relative flex w-full flex-col gap-8">
          <!-- Tool Name -->
          <div>
            <input
              formControlName="toolName"
              type="text"
              class="placeholder:text-mediumGray mt-2 w-full border p-2 text-xs placeholder:text-xs"
              placeholder="Name of the tool"
              data-cy="input-tool-name"
            />
            @if (toolSuggestionForm.get('toolName').touched && toolSuggestionForm.get('toolName').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">Tool name is required.</p>
            }
          </div>

          <!-- Description -->
          <div class="relative mb-2">
            <textarea
              formControlName="description"
              class="placeholder:text-mediumGray w-full resize-y border p-2 text-xs outline-none placeholder:text-xs"
              placeholder="Description of the tool"
              data-cy="input-tool-description"
              rows="4"
            ></textarea>
            @if (toolSuggestionForm.get('description').touched && toolSuggestionForm.get('description').invalid) {
              <p class="text-errorRed absolute -bottom-5 text-xs">Description is required.</p>
            }
          </div>

          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div class="w-full">
              <div class="w-full">
                <input
                  formControlName="website"
                  type="url"
                  class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                  placeholder="Website URL"
                  data-cy="input-tool-website"
                />
                @if (toolSuggestionForm.get('website').touched && toolSuggestionForm.get('website').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">Website URL is required and must be valid.</p>
                }
              </div>
              <!-- Website -->
            </div>
          </div>

          <div class="flex w-full justify-between max-md:gap-4">
            <button
              (click)="onCloseDialog.emit(false)"
              class="text-slateGray flex items-center border bg-white px-5 py-2 text-sm font-medium tracking-wider shadow-sm hover:bg-gray-100 hover:shadow-lg md:mb-0"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="bg-almostBlack text-sunflowerGold flex h-11 w-full items-center justify-center gap-2 border border-black p-5 text-xs md:w-48"
              data-cy="submit-tool-button"
            >
              Create Tool Suggestion
            </button>
          </div>
        </div>
      </form>
    } @else if (dialogType === EToolListType.REVIEW) {
      <form [formGroup]="toolReviewForm" (ngSubmit)="onSubmitReview()" class="flex flex-col items-center">
        <div class="relative flex w-full flex-col gap-8">
          <!-- AI Tool Image -->
          <div
            data-cy="add-tool-image"
            (click)="triggerFileInput()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            class="cursor-pointer justify-center"
            title="Add or drop image in square format"
          >
            <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />

            @if (selectedImage) {
              <div class="relative flex h-full min-h-[100px] w-full items-center justify-center">
                <img
                  class="max-h-48 object-cover"
                  [src]="selectedImage"
                  alt="ai-tool-image"
                  (load)="imageLoading = true"
                />
                @if (!imageLoading) {
                  <div class="absolute flex h-full w-full items-center justify-center">
                    <div
                      class="border-sunflowerGold h-10 w-10 animate-spin rounded-full border-2 border-solid border-t-transparent"
                    ></div>
                  </div>
                }
              </div>
              @if (toolReviewForm.get('image')?.hasError('notSquare')) {
                <div class="text-errorRed text-center text-xs">Image must be square (width equals height).</div>
              }
            } @else {
              <div class="flex w-full justify-center">
                <div class="flex h-48 w-full flex-col items-center justify-center bg-white">
                  <span class="text-2xl">➕</span>
                  <span class="text-sm">Add or drop square image</span>
                  <div class="flex flex-col">
                    @if (toolReviewForm.get('image')?.touched && toolReviewForm.get('image')?.hasError('required')) {
                      <p class="text-errorRed text-xs">Image is required.</p>
                    }
                  </div>
                </div>
              </div>
            }
          </div>

          <!-- Tool Name -->
          <div>
            <input
              formControlName="toolName"
              type="text"
              class="placeholder:text-mediumGray mt-2 w-full border p-2 text-xs placeholder:text-xs"
              placeholder="Name of the tool"
              data-cy="input-tool-name"
            />
            @if (toolReviewForm.get('toolName').touched && toolReviewForm.get('toolName').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">Tool name is required.</p>
            }
          </div>

          <!-- Description -->
          <div class="relative">
            <textarea
              formControlName="description"
              class="placeholder:text-mediumGray w-full resize-y border p-2 text-xs outline-none placeholder:text-xs"
              placeholder="Description of the tool"
              data-cy="input-tool-description"
              rows="4"
            ></textarea>
            @if (toolReviewForm.get('description').touched && toolReviewForm.get('description').invalid) {
              <p class="text-errorRed absolute -bottom-5 mt-2 text-xs">Description is required.</p>
            }
          </div>

          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div class="w-full">
              <!-- Company -->
              <div class="w-full">
                <input
                  formControlName="company"
                  type="text"
                  class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                  placeholder="Company name"
                  data-cy="input-tool-company"
                />
                @if (toolReviewForm.get('company').touched && toolReviewForm.get('company').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">Company name is required.</p>
                }
              </div>
            </div>
            <div class="w-full">
              <!-- Website -->
              <div class="w-full">
                <input
                  formControlName="website"
                  type="url"
                  class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                  placeholder="Website URL"
                  data-cy="input-tool-website"
                />
                @if (toolReviewForm.get('website').touched && toolReviewForm.get('website').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">Website URL is required and must be valid.</p>
                }
              </div>
            </div>
            <div class="w-full"></div>
            <div class="w-full">
              <!-- File URL (optional) -->
              <input
                formControlName="fileUrl"
                type="url"
                class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                placeholder="File link (optional)"
                data-cy="input-tool-outlook"
              />
              @if (toolReviewForm.get('fileUrl').touched && toolReviewForm.get('fileUrl').invalid) {
                <p class="text-errorRed absolute mt-1 text-xs">File URL must be valid.</p>
              }
            </div>
            <div class="flex w-full flex-col">
              <!-- Advantages -->
              <div class="w-full" data-cy="input-tool-advantages">
                <label class="mb-2 text-xs">Advantages</label>
                <div class="mt-2 flex items-center gap-2">
                  <!-- Input field for adding a new advantage -->
                  <input
                    [(ngModel)]="newAdvantage"
                    [formControl]="newAdvantageControl"
                    type="text"
                    class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                    placeholder="Add a new advantage"
                    (keyup)="onKeyUp($event, true)"
                    data-cy="input-tool-advantage"
                  />
                  <button
                    data-cy="add-advantage-button"
                    type="button"
                    (click)="addAdvantage()"
                    class="text-sunflowerGold w-16 text-xs whitespace-nowrap"
                  >
                    + Add
                  </button>
                </div>
                @if (toolReviewForm.get('advantages').touched && toolReviewForm.get('advantages').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">At least one advantage is required.</p>
                }
                <!-- List of added advantages -->
                <div class="flex max-h-40 flex-col overflow-auto">
                  @for (advantage of advantages.controls; track advantage; let i = $index; let last = $last) {
                    <div class="relative mt-2 flex w-[calc(100%-4rem)] items-center gap-2">
                      <div [ngClass]="{ 'border-b': !last }" class="w-5/6 py-2 pl-2 text-xs">
                        • {{ advantage.value }}
                      </div>

                      <img
                        (click)="removeAdvantage(i)"
                        src="../../../assets/img/icons/delete.png"
                        class="absolute right-4 h-4 cursor-pointer"
                        alt="delete icon"
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="flex w-full flex-col">
              <!-- Disadvantages -->
              <div class="w-full" data-cy="input-tool-disadvantages">
                <label class="mb-2 text-xs">Disadvantages</label>
                <div class="mt-2 flex items-center gap-2">
                  <!-- Input field for adding a new advantage -->
                  <input
                    [(ngModel)]="newDisadvantage"
                    [formControl]="newDisadvantageControl"
                    type="text"
                    class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                    placeholder="Add a new disadvantage"
                    (keyup)="onKeyUp($event)"
                    data-cy="input-tool-disadvantage"
                  />
                  <button
                    data-cy="add-disadvantage-button"
                    type="button"
                    (click)="addDisadvantage()"
                    class="text-sunflowerGold w-16 text-xs whitespace-nowrap"
                  >
                    + Add
                  </button>
                </div>
                @if (toolReviewForm.get('disadvantages').touched && toolReviewForm.get('disadvantages').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">At least one disadvantage is required.</p>
                }
                <!-- List of added advantages -->
                <div class="flex max-h-40 flex-col overflow-auto">
                  @for (disadvantage of disadvantages.controls; track disadvantage; let i = $index; let last = $last) {
                    <div class="relative mt-2 flex w-[calc(100%-4rem)] items-center gap-2">
                      <div [ngClass]="{ 'border-b': !last }" class="w-5/6 py-2 pl-2 text-xs">
                        • {{ disadvantage.value }}
                      </div>

                      <img
                        (click)="removeDisadvantage(i)"
                        src="../../../assets/img/icons/delete.png"
                        class="absolute right-4 h-4 cursor-pointer"
                        alt="delete icon"
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Conclusion -->
          <div class="relative">
            <textarea
              formControlName="conclusion"
              class="placeholder:text-mediumGray w-full resize-y border p-2 text-xs outline-none placeholder:text-xs"
              placeholder="What is the conclusion?"
              data-cy="input-tool-summary"
            ></textarea>
            @if (toolReviewForm.get('conclusion').touched && toolReviewForm.get('conclusion').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">Conclusion is required.</p>
            }
          </div>

          <!-- Categories -->
          <div>
            <label class="mb-2 text-xs">Categories</label>
            <div data-cy="categories" class="mt-2 flex w-full flex-wrap items-center gap-3 max-lg:justify-center">
              @for (tag of categories; track tag) {
                <div
                  (click)="onTagSelected(tag)"
                  [ngClass]="toolReviewForm.get('category').value === tag ? 'bg-sunflowerGold text-white' : ''"
                  class="border-sunflowerGold flex cursor-pointer gap-2 rounded-sm border px-2 py-1 text-xs"
                >
                  <fa-icon
                    [icon]="badgeIcon"
                    [ngClass]="toolReviewForm.get('category').value === tag ? 'text-white' : 'text-sunflowerGold'"
                  ></fa-icon>

                  <span>{{ tag }}</span>
                </div>
              }
            </div>
            @if (toolReviewForm.get('category').touched && toolReviewForm.get('category').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">At least one category has to be selected.</p>
            }
          </div>

          <div class="flex w-full justify-between max-md:gap-4">
            <button
              type="button"
              (click)="onCloseDialog.emit(false)"
              class="text-slateGray flex items-center border bg-white px-5 py-2 text-sm font-medium tracking-wider shadow-sm hover:bg-gray-100 hover:shadow-lg md:mb-0"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="bg-almostBlack text-sunflowerGold flex h-11 w-full items-center justify-center gap-2 border border-black p-5 text-xs md:w-40"
              data-cy="submit-tool-button"
            >
              {{ editingMode ? 'Update Tool Review' : 'Create Tool Review' }}
            </button>
          </div>
        </div>
      </form>
    } @else {
      <form [formGroup]="toolUseCaseForm" (ngSubmit)="onSubmitUseCase()" class="flex flex-col items-center">
        <div class="relative flex w-full flex-col gap-8">
          <!-- Use Case Name -->
          <div>
            <input
              formControlName="title"
              type="text"
              class="placeholder:text-mediumGray mt-2 w-full border p-2 text-xs placeholder:text-xs"
              placeholder="Title of the Use Case"
              data-cy="input-use-case-title"
            />
            @if (toolUseCaseForm.get('title').touched && toolUseCaseForm.get('title').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">Use Case name is required.</p>
            }
          </div>

          <!-- Description -->
          <div class="relative">
            <textarea
              formControlName="description"
              class="placeholder:text-mediumGray min-h-[3rem] w-full resize-y border p-2 text-xs outline-none placeholder:text-xs"
              placeholder="Description of the Use Case"
              data-cy="input-use-case-description"
            ></textarea>
            @if (toolUseCaseForm.get('description').touched && toolUseCaseForm.get('description').invalid) {
              <p class="text-errorRed absolute mt-1 text-xs">Description is required.</p>
            }
          </div>

          <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div class="w-full">
              <div class="w-full">
                <input
                  formControlName="website"
                  type="url"
                  class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                  placeholder="Website URL (optional)"
                  data-cy="input-use-case-website"
                />
                @if (toolUseCaseForm.get('website').touched && toolUseCaseForm.get('website').invalid) {
                  <p class="text-errorRed absolute mt-1 text-xs">Website URL must be valid.</p>
                }
              </div>
              <!-- Website -->
            </div>
            <div class="w-full">
              <!-- File URL (optional) -->
              <input
                formControlName="fileUrl"
                type="url"
                class="placeholder:text-mediumGray w-full border p-2 text-xs placeholder:text-xs"
                placeholder="File link (optional)"
                data-cy="input-use-case-outlook"
              />
              @if (toolUseCaseForm.get('fileUrl').touched && toolUseCaseForm.get('fileUrl').invalid) {
                <p class="text-errorRed absolute mt-1 text-xs">File URL must be valid.</p>
              }
            </div>
          </div>
          <div class="flex w-full justify-between max-md:gap-4">
            <button
              type="button"
              (click)="onCloseDialog.emit(false)"
              class="text-slateGray flex items-center border bg-white px-5 py-2 text-sm font-medium tracking-wider shadow-sm hover:bg-gray-100 hover:shadow-lg md:mb-0"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="bg-almostBlack text-sunflowerGold flex h-11 w-full items-center justify-center gap-2 border border-black p-5 text-xs md:w-40"
              data-cy="submit-use-case-button"
            >
              {{ editingMode ? 'Update Use Case' : 'Create Use Case' }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
